"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncQueueAdapter = void 0;
const domain_1 = require("@home-health-notify/domain");
const Urls_1 = require("../Urls");
// A disabled EMR feature answers these endpoints with 403. That is a feature
// gate, not an auth failure, so opt out of the force-logout the auth response
// interceptor applies to 401/403.
const ALLOW_FORBIDDEN = { allowForbidden: true };
class SyncQueueAdapter {
    constructor(httpAdapter, config) {
        this.httpAdapter = httpAdapter;
        this.config = config;
    }
    getSyncQueue(params, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const queryParams = {};
                if (params.status) {
                    queryParams.status = params.status;
                }
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.syncQueue, Object.assign(Object.assign({}, ALLOW_FORBIDDEN), { params: queryParams, signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()) }));
                return (0, domain_1.CompletedResult)(response.data.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    approveSyncQueueItem(id, socDiscipline) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                const body = socDiscipline ? { socDiscipline } : undefined;
                const response = yield this.httpAdapter.post(this.config.baseUrl + Urls_1.urls.approveSyncQueueItem(id), body, ALLOW_FORBIDDEN);
                return response.data.data;
            }
            catch (e) {
                throw (_a = domain_1.ApiError.fromAxiosError(e)) !== null && _a !== void 0 ? _a : e;
            }
        });
    }
    rejectSyncQueueItem(id, comment) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                yield this.httpAdapter.post(this.config.baseUrl + Urls_1.urls.rejectSyncQueueItem(id), { comment }, ALLOW_FORBIDDEN);
            }
            catch (e) {
                throw (_a = domain_1.ApiError.fromAxiosError(e)) !== null && _a !== void 0 ? _a : e;
            }
        });
    }
}
exports.SyncQueueAdapter = SyncQueueAdapter;
